/**
 * page : 이용안내
 */
import { useEffect } from "react";
import { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Editor } from "@tinymce/tinymce-react";
import Parser from 'html-react-parser';
import * as zy from '../common/zeroyear-1.0.0';
import '../assets/js/nav.js';
import orgImg from '../assets/img/orgChartImg.png';
let sessionStorage = window.sessionStorage;

export default function OrgChartPage () {
    const [admin, setAdmin] = useState(false);
    // 인사말 Content01 Edit용, 조회용 변수 2개 선언
    const [contentEdit, setContentEdit] = useState('');
    const [content, setContent] = useState('');
    const [data, setData] = useState('');
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showModalImg, setShowModalImg] = useState(false);
    /**
     * close modal
     */
    const closeModal = () => {
        setContentEdit(content);
        setShowModal(false);
    };
    /**
     * open modal
     */
    const openModal = () => { setShowModal(true); };
    const selectAll = () => {
        zy.select('selectOrgChartContent02', [], (item) => {
            let co10 = item.find((c) => c.ORG_CHRT_DV_CD === '10');
            let co20 = item.find((c) => c.ORG_CHRT_DV_CD === '20');
            setData(co10.ORG_CHRT_CONTENT);
            setContent(co20.ORG_CHRT_CONTENT);
            setContentEdit(co20.ORG_CHRT_CONTENT);
        });
    };
    /**
     * close modal
     */
    const closeModalImg = () => {
        setShowModalImg(false);
    };
    /**
     * open modal
     */
    const openImgEditModal = () => {
        setShowModalImg(true);
    };
    /**
     * content change hanlder
     */
    const setContentEditChange = (data) => {
        setContentEdit(data||'');
    };
    const btnContentSave = () => {
        zy.modify('updateOrgChartContent02', [contentEdit, '20'],(item) => {
            selectAll();
            closeModal();
        });
    };
    const saveOrgImg = () => {
        zy.modify('updateOrgChartContent02', [data, '10'],(item) => {
            selectAll();
            closeModal();
        });
    };
    /**
     * 이미지 파일 change event
     */
    const changeImage = (event) => {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = function (e) {
            setData(e.target.result);
        }
    };
    useEffect(() => {
        selectAll();
        setAdmin(sessionStorage.getItem('isLogin'));
    }, []);
    return (
        <>
        <main id="main">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><a className="gg-font-color">회사소개</a></li>
                        <li>조직도</li>
                    </ol>
                    <h2>조직도</h2>
                </div>
            </section>
            <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    <div className="col-lg-12">
                        <div className="portfolio-info ori-table">
                            {admin ? <button className="btn-cancel" onClick={openImgEditModal}>조직도 이미지 변경</button> : null}
                            <div style={{textAlign: 'center'}}>
                                <img src={data} style={{maxWidth: '100%'}}></img>
                            </div>
                            {admin ? <button className="btn-cancel" onClick={openModal}>수정</button> : null}
                            {Parser(content)}
                        </div>
                    </div>
                </div>
            </section>
            <Modal 
                show={showModal}
                onHide={closeModal}
                backdrop="static"
                keyboard={false}
                centered
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>수정</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Editor
                        apiKey={'g473ctmydd0wpefxozp61yzmmfhdzfkv7o2m6czhrwe9b1ct'}
                        value={contentEdit}
                        id='tinyMce_editor'
                        init={{
                            height: 600,
                            menubar: false,
                            plugins: [
                                'lists',
                                'link',
                                'image',
                                'charmap',
                                'preview',
                                'searchreplace',
                                'fullscreen',
                                'media',
                                'table',
                                'code',
                                'help',
                                'emoticons',
                                'codesample',
                                'quickbars',
                            ],
                            toolbar:
                                'undo redo | blocks | ' +
                                'lists table link charmap searchreplace | ' +
                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                'bold italic forecolor | alignleft aligncenter ' +
                                'image media codesample emoticons fullscreen preview | ' +
                                'removeformat | help ',
                        }}
                        onEditorChange={setContentEditChange}
                    />
                    <Modal.Footer>
                        <button className="btn-cancel" onClick={closeModal}>닫기</button>
                        <button className="btn-normal" onClick={btnContentSave}>등록완료</button>
                    </Modal.Footer>
                </Modal.Body>
            </Modal>
            <Modal 
                show={showModalImg}
                onHide={closeModalImg}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered>
                <Form noValidate onSubmit={saveOrgImg}>
                    <Modal.Header closeButton>
                    <Modal.Title>이미지 등록</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="d-input mb-3" controlId="Perf_TITLE">
                            <Form.Label>이미지 선택</Form.Label>
                            <Form.Control
                                type="file"
                                accept="image/gif, image/jpeg, image/png"
                                onChange={changeImage}
                                placeholder=""
                                required/>
                            <Form.Control.Feedback type="invalid">제목을 입력해주세요.</Form.Control.Feedback>
                        </Form.Group>
                        <Modal.Footer>
                            <button className="btn-cancel" onClick={closeModalImg}>닫기</button>
                            <button className="btn-normal" type="submit">등록</button>
                        </Modal.Footer>
                    </Modal.Body>
                </Form>
            </Modal>
        </main>
        </>
    );
}
